import React, { useEffect } from 'react';
import './SubSectionsComponent.css';
import FocusTrap from "@mui/material/Unstable_TrapFocus";

type Row = {
  project_name: string;
  stage_name: string;
  section_name: string;
  subsection_name: string;
};

type SegmentBoxProps = {
  data: Row[];
  isLoading?: boolean;
  title?: string;
  maxHeight?: number;
  onClose: () => void;
  className?: string;
  showArrows?: boolean;
};

const SubSectionsComponent: React.FC<SegmentBoxProps> = ({
  data,
  isLoading = false,
  title = 'רשימת תתי המקטעים של התקנת תשתיות',
  maxHeight = 300,
  onClose,
  className = '',
  showArrows = true
}) => {

  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === "Escape" || event.key === "Esc" || event.keyCode === 27) {
        onClose();
      }
    }

    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("keydown", handleEsc);
    }
  }, [onClose])

  return (
    <FocusTrap open={true}>
      <div aria-labelledby="sc-title" role={"dialog"} className={`segment-box ${className}`}>
        <div className="segment-content" style={{ maxHeight }}>
          <div className="segment-inner">
            <button autoFocus={true} className="close-btn" onClick={onClose}>X</button>
            <h2 id="sc-title" className="sc-title">{title}</h2>

            {isLoading ? (
              <div className="loader" />
            ) : (
              data.map((row, index) => (
                <nav aria-label={row.project_name} role="list" key={index} className="sub-segment">
                  <span role="listitem" className="segment-title">{row.project_name}</span>
                  {showArrows && <img src="/images/blue_arrow.svg" alt="" className="blue-arrow" />}
                  <span role="listitem" className="subsegment-name">{row.stage_name}</span>
                  {showArrows && <img src="/images/blue_arrow.svg" alt="" className="blue-arrow" />}
                  <span role="listitem" className="subsegment-section">{row.section_name}</span>
                  {showArrows && <img src="/images/blue_arrow.svg" alt="" className="blue-arrow" />}
                  <span role="listitem" className="subsegment-station">{row.subsection_name}</span>
                </nav>
              ))
            )}
          </div>
        </div>
      </div>
    </FocusTrap>
  );
};

export default SubSectionsComponent;